<template>
  <div class="inner">
    <div class="page_con">
      <div class="table_search">
        <div class="select">
          <select name="" id="">
            <option value="">제목</option>
          </select>
        </div>
        <div class="search_wrap">
          <div class="input">
            <input type="search" placeholder="검색" v-model="params.searchText" v-on:keyup.enter="fetchData(1)">
          </div>
          <button class="btn" v-on:click="fetchData(1)">검색</button>
        </div>
      </div>
      <div class="m_table">
        <ul class="m_table_ul">
          <li class="m_table_li" v-for="(item, index) in list" :key="index" @click="fnView(item.inquiry)">
            <div class="col">
              <div class="tag" :class="{'grey': item.inquiry.isAnswer === 2}"><span>{{ item.inquiry.isAnswer === 1 ? '답변완료' : '답변대기' }}</span></div>
              <div class="m_table_con">
                <span class="lock" :class="{ 'on' : item.inquiry.isSecret === 2}"></span><!--'on 추가'-->
                <span>
                                        {{ item.inquiry.title }}
                                    </span>
              </div>
              <div class="date"><span> {{ `${item.user.userId.replace( (item.user.userId).substring(item.user.userId.length -2, item.user.userId.length), '**' )} | ${$moment(item.inquiry.regDate).format('YYYY.MM.DD')}` }}</span></div>
            </div>
          </li>
        </ul>
        <base-list-scroll-page
          v-bind:page="params.page"
          v-bind:currentIndex="currentIndex"
          v-bind:isActive="true"
          v-bind:listFunction="listFunction"
          v-on:finishFetch="fnFinishFetch"
        />
      </div>
      <div class="m_table" v-if="$Util.isEmpty(list)">
        <div class="empty_wrap">
          <div class="empty">
            <span>내역이 존재하지 않습니다.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="page_btn">
      <button class="btn" @click="fnWrite">글쓰기</button>
    </div>
    <top-button />
  </div>
</template>

<script>
import TopButton from '@/components/pages/top/button'
export default {
  name: 'info-report-index',
  components: {TopButton},
  data() {
    return {
      params: {
        page: 1,
        limit: 10,
        searchText: '',
        isSecret: '',
        boardType: 2
      },
      pageInfo: {},
      list: [],
      currentIndex: 1
    }
  },
  computed: {
    userData: function() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    fetchData: async function(page) {
      this.params.page = page
      this.currentIndex++
      const res  = await this.$InquirySvc.fetchInquiryList(this.params)
      if (res.code === 1) {
        this.list = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    listFunction: function ({ page }) {
      let params = Object.assign({}, this.params)
      params.page = page
      return this.$InquirySvc.fetchInquiryList(params)
    },
    fnFinishFetch: function(items, pageInfo) {
      this.list = items
      this.pageInfo = pageInfo
    },
    fnView: function(inquiry) {
      if (inquiry.isSecret === 2) {
        if (this.userData.userNo !== inquiry.userNo) {
          alert('작성자와 관리자만 열람하실 수 있습니다.')
          return false
        }
      }
      this.$router.push({
        path: '/info/report/view',
        query: { inquiryNo: inquiry.inquiryNo }
      })
    },
    fnWrite: function() {
      this.$router.push({ path: '/info/report/write' })
    },
    fnBoard: function(path, boardType) {
      this.$store.commit('education/setBoardType', {boardData: {boardType: boardType}})
      this.$router.push({ path: path })
    }
  }
}
</script>

<style scoped>

</style>
